import React, { useState } from 'react';
import { BaSeDialogContext } from '@base/react';

export default (props) => {
  const { showModal } = React.useContext(BaSeDialogContext);
  const [pendants, setPendants] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [inputSearchValue, setInputSearchValue] = useState('');
  const [paginationFilters, setPaginationFilters] = useState({
    page: 0,
    linesPerPage: 10,
    orderBy: props?.orderBy || 'id',
    direction: 'DESC',
  });

  const onLinesPerPageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      linesPerPage: value,
      page: 0,
    });
  };

  const handlePageChange = (value) => {
    setPaginationFilters({
      ...paginationFilters,
      page: value,
    });
  };

  const handleOrderClick = ({ orderBy, direction }) => {
    setPaginationFilters({
      ...paginationFilters,
      orderBy: orderBy,
      direction: direction,
    });
  };

  const handleInputPageChange = (newValue) => {
    setPaginationFilters({
      ...paginationFilters,
      page: newValue,
    });
  };

  const handleFilterByStatus = (status) => {
    if (JSON.stringify(status) === JSON.stringify(filters?.status)) {
      setFilters((f) => ({ ...f, status: null }));
      return;
    }
    setFilters((f) => ({ ...f, status: status }));
    setPaginationFilters({
      ...paginationFilters,
      page: 0,
    });
  };

  return {
    handleOrderClick,
    handleInputPageChange,
    handleFilterByStatus,
    handlePageChange,
    onLinesPerPageChange,
    filters,
    setFilters,
    paginationFilters,
    setPaginationFilters,
    inputSearchValue,
    setInputSearchValue,
    isLoading,
    setIsLoading,
    pendants,
    setPendants,
    filterOptions,
    setFilterOptions,
    showModal,
  };
};
